import { map, Observable } from 'rxjs';
import { AppendState } from 'src/core/state/cart';
import { CartState } from 'src/util/test-utils';

export function getCartItems(state: Observable<AppendState>): Observable<CartState['items']> {
    return state.pipe(map((s) => s?.cart?.items));
}
